var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.bemBlock }, [
    _c("img", {
      class: _vm.bemElement("img"),
      attrs: { src: _vm.imageUrl, alt: _vm.complement },
      on: {
        load: function($event) {
          return _vm.$emit("complement-visualizer:show")
        }
      }
    }),
    _vm._v(" "),
    _vm.editMode
      ? _c(
          "button",
          {
            class: [_vm.bemElement("remove-button"), "btn", "btn-clean"],
            on: { click: _vm.handleRemoveClick }
          },
          [
            _c(
              "span",
              { staticClass: "icon", attrs: { "aria-hidden": "true" } },
              [_vm._v("+")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "sr-only" }, [_vm._v(" Remove ")])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }